// ===================================================
// FOTOS — PEDIDOS
// ===================================================
let _pedidoFotosTemp = [];

function pedidoFotoPath(foto){return typeof foto==='string'?foto:(foto?.path||'');}
function pedidoFotoPreview(foto){
  if(!foto)return '';
  if(typeof foto==='string')return /^data:|^https?:|^blob:/i.test(foto)?foto:'';
  return foto.dataUrl||foto.previewUrl||foto.url||(/^data:|^https?:|^blob:/i.test(String(foto.path||''))?foto.path:'');
}
function pedidoArquivoFotoDataUrl(file,max=720,quality=.82){
  return new Promise(resolve=>{
    const reader=new FileReader();
    reader.onload=e=>{
      const raw=e.target.result;
      const img=new Image();
      img.onload=()=>{
        try{
          const scale=Math.min(1,max/Math.max(img.width,img.height));
          const canvas=document.createElement('canvas');
          canvas.width=Math.max(1,Math.round(img.width*scale));
          canvas.height=Math.max(1,Math.round(img.height*scale));
          const ctx=canvas.getContext('2d');
          ctx.drawImage(img,0,0,canvas.width,canvas.height);
          resolve(canvas.toDataURL('image/jpeg',quality));
        }catch(e){resolve(raw);}
      };
      img.onerror=()=>resolve(raw);
      img.src=raw;
    };
    reader.onerror=()=>resolve('');
    reader.readAsDataURL(file);
  });
}

function renderPedidoFotosGrid(){
  const grid = document.getElementById('pedido-fotos-grid');
  if(!grid) return;
  if(!_pedidoFotosTemp||!_pedidoFotosTemp.length){
    grid.innerHTML='<div style="color:var(--muted);font-size:12px;padding:8px 0">Nenhuma foto adicionada</div>';
    return;
  }
  grid.innerHTML = _pedidoFotosTemp.map((p,i)=>{
    const preview=pedidoFotoPreview(p);
    return `
    <div style="position:relative;width:80px;height:80px;border-radius:8px;overflow:hidden;border:1px solid var(--border);flex-shrink:0" id="pedfoto-${i}">
      <img src="${escapeHtml(preview)}" style="width:100%;height:100%;object-fit:cover;background:var(--surface2)" loading="lazy" alt="Foto do pedido ${i+1}">
      <button onclick="pedidoFotoRemover(${i})" style="position:absolute;top:2px;right:2px;background:#f06595;color:#fff;border:none;border-radius:50%;width:18px;height:18px;font-size:11px;cursor:pointer;line-height:18px;padding:0">×</button>
    </div>`;}).join('');
  _pedidoFotosTemp.forEach((p,i)=>{
    const path=pedidoFotoPath(p);
    if(!path)return;
    dbxGetThumbnailUrl(path).then(url=>{
      const img = document.querySelector('#pedfoto-'+i+' img');
      if(img&&url) img.src=url;
    }).catch(()=>{});
  });
}

function pedidoFotoRemover(i){
  _pedidoFotosTemp.splice(i,1);
  renderPedidoFotosGrid();
}

// Upload de documentos (PDF, projeto, referência) vinculados ao pedido
let _pedidoDocsTemp=[];
async function pedidoUploadDoc(){
  if(!await dbxEnsureToken()){toast('Conecte o Dropbox primeiro','error');return;}
  const input=document.createElement('input');
  input.type='file';input.accept='.pdf,.doc,.docx,.dwg,.dxf,.jpg,.jpeg,.png,.heic';input.multiple=true;
  input.onchange=async()=>{
    const files=[...input.files];
    if(!files.length)return;
    const pedId=document.getElementById('pid')?.value||'novo',pedNum=(document.getElementById('p-num')?.value||pedId).replace(/[^a-zA-Z0-9_-]/g,'_');
    const dataISO=new Date().toISOString().slice(0,10),ano=dataISO.slice(0,4),mes=dataISO.slice(5,7);
    const btn=document.getElementById('ped-doc-btn');
    if(btn){btn.disabled=true;btn.textContent='⏳ Enviando...';}
    for(const file of files){
      const ext=file.name.split('.').pop().toLowerCase()||'pdf';
      const ts=Date.now();
      const path=`/Orcamentos/${ano}/${mes}/Pedido_${pedNum}/docs/${dataISO}_${ts}_${file.name.replace(/[^a-zA-Z0-9._-]/g,'_')}`;
      try{
        const result=await dbxUploadFile(path,file);
        if(result&&!result.error_summary){
          _pedidoDocsTemp.push({path,nome:file.name,ext});
          renderPedidoDocsList();
        } else { toast('Erro ao enviar arquivo','error'); }
      } catch(e){ toast('Erro no upload: '+e.message,'error'); }
    }
    if(btn){btn.disabled=false;btn.textContent='📎 PDF / Projeto / Referência';}
  };
  input.click();
}
function renderPedidoDocsList(){
  const el=document.getElementById('pedido-docs-list');if(!el)return;
  if(!_pedidoDocsTemp.length){el.innerHTML='';return;}
  el.innerHTML=_pedidoDocsTemp.map((d,i)=>`<div style="display:inline-flex;align-items:center;gap:4px;background:var(--surface2);border:1px solid var(--border);border-radius:6px;padding:3px 8px;margin:2px;font-size:11px">📎 ${escapeHtml(d.nome)} <button onclick="pedidoDocRemover(${i})" style="background:none;border:none;color:var(--muted);cursor:pointer;font-size:12px;padding:0;line-height:1">×</button></div>`).join('');
}
function pedidoDocRemover(i){_pedidoDocsTemp.splice(i,1);renderPedidoDocsList();}

async function pedidoUploadFoto(){
  if(!await dbxEnsureToken()){toast('Conecte o Dropbox primeiro','error');return;}
  const input=document.createElement('input');
  input.type='file';input.accept='image/*';input.multiple=true;
  input.onchange=async()=>{
    const files=[...input.files];
    if(!files.length) return;
    const pedId=document.getElementById('pid')?.value||'novo',pedNum=(document.getElementById('p-num')?.value||pedId).replace(/[^a-zA-Z0-9_-]/g,'_');
    const dataISO=new Date().toISOString().slice(0,10),ano=dataISO.slice(0,4),mes=dataISO.slice(5,7);
    const btn=document.getElementById('ped-foto-btn');
    if(btn){btn.disabled=true;btn.textContent='⏳ Enviando...';}
    for(const file of files){
      const ext=file.name.split('.').pop()||'jpg';
      const ts=Date.now();
      const path=`/Orcamentos/${ano}/${mes}/Pedido_${pedNum}/${dataISO}_${ts}.${ext}`;
      try{
        const dataUrl=await pedidoArquivoFotoDataUrl(file);
        const result=await dbxUploadFile(path,file);
        if(result&&!result.error_summary){
          _pedidoFotosTemp.push({path,nome:file.name,dataUrl});
          renderPedidoFotosGrid();
        } else { toast('Erro ao enviar foto','error'); }
      } catch(e){ toast('Erro no upload: '+e.message,'error'); }
    }
    if(btn){btn.disabled=false;btn.textContent='📷 Adicionar foto';}
  };
  input.click();
}

